document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.food-waste.prr-site-content')) {
    const foodHeader = document.querySelector('.food-header');
    const siteHeader = document.querySelector('.site-header.secondary-header');
    const content = this.documentElement.querySelector('.prr-site-content');
    const alertBtn = document.querySelector('.header-alert .alert-hide-btn');
  
    let lastScrollPos = 0;
  
    // Scroll the page by 2 pixel when it loads, so we can detect scroll to top event while on top of the page
    window.addEventListener("load", () => {
      setTimeout(function() {
        window.scrollTo(0, 2);
      }, 100);
      setTimeout(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
      }, 150);
    });
  
    function handleScroll() {
      if (foodHeader && window.scrollY > 50) {
        foodHeader.classList.add('smaller');
      }
      if (foodHeader && window.scrollY < 10) {
        foodHeader.classList.remove('smaller');
        siteHeader.style.transform = 'translateY(0)'
        foodHeader.style.top = `${siteHeader.offsetHeight}px`;
        content.style.marginTop = `${foodHeader.offsetHeight + siteHeader.offsetHeight}px`;
      }
  
      // Detect scroll direction
      const currentScrollPos = window.scrollY;
      if (currentScrollPos > lastScrollPos) {
        // Scrolling down
        siteHeader.style.transform = `translateY(-${siteHeader.offsetHeight}px)`
        foodHeader.style.top = 0;
        content.style.marginTop = `${foodHeader.offsetHeight}px`;
      }
  
      lastScrollPos = currentScrollPos;
    }
  
    if (alertBtn) {
      alertBtn.addEventListener('click', () => {
        setTimeout(() => {
          foodHeader.style.top = `${siteHeader.offsetHeight}px`;
        }, 100);
      })
    }
  }
})

function toggleTabletMenu(button) {
  let tabletDropdown = button.parentNode;
  
  tabletDropdown.classList.toggle('open');
}

function toggleLanguages(button) {
  let languageDropdown = button.parentNode;
  let options = languageDropdown.querySelector('.lang-options')

  if (options.style.display === "block") {
    options.style.display = "none";
  } else {
    options.style.display = "block";
  }
}

function openMobileMenu() {
  const mobileMenu = document.querySelector('.food-header__mobile-menu');

  if (mobileMenu) {
    mobileMenu.classList.add('open');
  }
}

function closeMobileMenu() {
  const mobileMenu = document.querySelector('.food-header__mobile-menu');

  if (mobileMenu) {
    mobileMenu.classList.remove('open');
  }
}

